import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { LengthBarRow } from "../models/LengthBarRow";
import { LengthBundleRow } from "../models/LengthBundleRow";
import { LengthPieceRow } from "../models/LengthPieceRow";

const moment = getMomentTz();

type GetLengthBundlesProps = {
	start: Date;
	end: Date;
	productCode?: number | null;
};

export const getLengthBundles = async ({
	start,
	end,
	productCode,
}: GetLengthBundlesProps) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start.toISOString() },
		{ name: "End", value: end.toISOString() },
		{ name: "ProductCode", value: productCode ?? null },
	];

	const resp = await apiService.callV2(
		"[FAB].[GetBundlesProduction]",
		parameters,
	);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []).map(
			(row: Record<string, unknown>) => ({
				...row,
				StartTime: row.StartTime ? moment.utc(row.StartTime).toDate() : null,
				EndTime: row.EndTime ? moment.utc(row.EndTime).toDate() : null,
			}),
		) as LengthBundleRow[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching bundles");
};

export const getDistinctProductCodes = async (): Promise<number[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[FAB].[GetDistinctProductCodes]", []);
	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []).map(
			(row: Record<string, unknown>) => row.ProductCode as number,
		);
	}
	throw new Error(resp.message || "Error fetching product codes");
};

type GetAllBarsProps = {
	start: Date;
	end: Date;
	productCode?: number | null;
	shiftId?: number | null;
};

export const getAllBars = async ({
	start,
	end,
	productCode,
	shiftId,
}: GetAllBarsProps) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start.toISOString() },
		{ name: "End", value: end.toISOString() },
		{ name: "ProductCode", value: productCode ?? null },
		{ name: "ShiftId", value: shiftId ?? null },
	];

	const resp = await apiService.callV2("[FAB].[GetAllBars]", parameters);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []).map(
			(row: Record<string, unknown>) => ({
				...row,
				Timestamp: row.Timestamp ? moment.utc(row.Timestamp).toDate() : null,
				BundleStartTime: row.BundleStartTime
					? moment.utc(row.BundleStartTime).toDate()
					: null,
				BundleEndTime: row.BundleEndTime
					? moment.utc(row.BundleEndTime).toDate()
					: null,
			}),
		) as LengthPieceRow[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching bars");
};

export const getBarsByBundle = async (bundleId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "BundleId", value: bundleId }];

	const resp = await apiService.callV2("[FAB].[GetBarsByBundle]", parameters);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []).map(
			(row: Record<string, unknown>) => ({
				...row,
				Timestamp: row.Timestamp ? moment.utc(row.Timestamp).toDate() : null,
			}),
		) as LengthBarRow[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching bars");
};
